import {
  usersLogin,
  getAllRoles,
  getAdminList,
  getClientEntities,
  getUserDetails,
  postCreateAdmin,
  putUpdateClient,
  postCreateClient,
  getClients,
  putDeleteClient,
  putStoreStatus,
  putUpdateClientEntity,
  postCreateClientEntity,
  getEntityTypeList,
  getVenueList,
  putVenueStatus,
  postCreateVenue,
  putUpdateVenue,
  putUpdateAdminDetails,
  putUpdateAdminRole,
  putUpdateAdminStatus,
  getShopType,
  getStarRating,
  getBriefJson,
  putUpdateEditors,
  putVenueEditors,
  getVisitTimes,
  postVisitTimes,
  putVisitTimes,
  postClientEntityTemplate,
  getClientEntityTemplateByClientEntityId,
  postVenueTemplate,
  getVenueEntityTemplateByClientEntityId,
  putClientEntityTemplate,
  getAllocations,
  putUpdateAllocation,
  postCreateAllocations,
  getAllShoppersApplications,
  putUpdateShopperApplicationStatus,
  getAppliedAllocations,
  postUpdateAppliedAllocationStatus,
  getShopper,
  getOrphanAllocations,
  getNearbyShopper,
  postInviteShopper,
  getcategories,
  getentities,
  addquestions,
  updatequestions,
  getquestions,
  getquestiontemplate,
  uploadVenueImage,
  addquestiontemplate,
  updatequestiontemplate,
  deletequestiontemplate,
  gettemplatequestions,
  addtemplatequestions,
  removetemplatequestions,
  putCancelJob,
  getcliententityquestions,
  addbusinessquestions,
  removebusinessquestions,
  updatebusinessquestions,
  addvenuequestions,
  getvenuequestions,
  removevenuequestions,
  updatevenuequestions,
  updatevenuequestionorder,
  updatevenuecategoryorder,
  getClientDbName,
  masterRating,
  reportlist,
  getShopperFeedback,
  postShopperFeedback,
  getReportDetails,
  scoreCardStep1,
  scoreCardStep2,
  scoreCardStep3,
  deletePhotos,
  updatevisittime,
  reportPdf,
  updateReportStatus,
  getStarRatingReport,
  getSpentReport,
  getClientEntityByClientGroupId,
  postAreaManager,
  getAreaManagers,
  putAreaManager,
  getAddOnQuestions,
  uploadDocuments,
  postQuizQuestion,
  getQuizQuestions,
  putQuizQuestions,
  submitQuiz,
  deleteQuizQuestion,
  getShopperList,
  putShopperDetails,
  putShopperFinancialDetails,
  getShopperDetails,
  getShopperRelativeVenues,
  getShopperVenueMap,
  getShopperPopUpDetails,
  getCategoryList,
  addCategory,
  updateCategory,
  quizreTake,
  getManageRegions,
  postRegion,
  putRegion,
  postAssignRegionToClientEntity,
  getBusinessRegions,
  getClientEntityComparisionsByEntityType,
  getVenuePreviousReport,
  getApprovedAllocationShopper,
  getRegionBusinessDetails,
  postregionBusinessDetail,
  putQuizBrief,
  delReportMessage,
  getAllocationCriteriaDetails,
  createAirTasker,
  updateAirTasker,
  deleteAirTasker,
  getAirTasker,
  deleteInvitedAirTasker,
  getallocations,
  createbundleallocations,
  getbundleallocations,
  getappliedbundleallocations,
  getbundlelist,
  postupdateappliedbundleallocations,
  holdappliedallocations,
  holdbundleappliedallocations,
  criteriamessage,
  updatedatetime,
  importexportallocationpointsdata,
  importexportallocationtabledata,
  getCompleteAllocation,
  getinvoicereportlist,
  resetallocation,
  deleteallocation,
  editorcliententities,
  editorvenuelist,
  generateinvoice,
  invoicestatus,
  getgeneratedinvoicelist,
  updatebulkstatus,
  getMonthlyAllocation,
  getinvoiceitem,
  updateinvoiceitem,
  getPriceChangeLogs,
  getAllocationForUpdate,
  updateAllocationPrice,
  deleteAllocationPriceChangeLogsById,
  downloadAllAsXlsInImportExportAllocation,
  downloadExcelForOrphanInImportExportAllocation,
  downloadPdfByStatusInImportExportAllocation,
  generatemasterinvoiceexcel,
  shopperwiseinvoiceexcel,
  shopperinvoiceexcel,
  shopperinvoicepdf,
  getStarRankingReportYTD,
  getAirTaskerTasks,
  getExcelDataForAirTaskerJobs,
  assignShooperAllocation,
  generatelogintoken,
  getRestrictVenues,
  addRestrictVenue,
  deleteRestrictVenue,
  starRatingExcel,
  getClientEntityComparisionsByEntityTypeExcel,
  ratingReportYTD,
  updateallocationdatetime,
  reporttemptoken,
  createEmailPreference,
  getEmailPreference,
  deleteEmailPreference,
  updateEmailPreference,
  ManageHolidays,
  exportcheckedshopper,
  generatereportinvoiceexcel,
  downloadVenuesExcel,
  downloadBusinessExcel,
  downloadBusinessQuestionExcel,
  downloadVenuesQuestionExcel,
  getAddOnQuestionList,
  importVeneus,
  getSpentReportExcel,
  ChangeApproveAllocationsDate,
  ChangeOrphanAllocationsDate,
  BulkResetAllocation,
  updateBundleAllocation,
  deleteBundleAllocation,
  getDocumentType,
  getDocument,
  createDocument,
  updateHelpingDocument,
  deleteHelpingDocument,
  newBundleList,
  newCreateBundleList,
  updateNewBundleList,
  deleteNewBundleList,
  getNewAppliedBundleAllocation,
  approveShopperBundle,
  BulkResetAllocationData,
  bulkAssignShopper,
  downloadBulkRegionUpdate,
  uploadBulkRegionUpdateExcel,
  updateallocationdatetimewithoutrequest,
  exportRoasterMaster,
  rejectAppliedAllocation,
  getUserByClientId,
  createOrUpdateUserByClientId,
  deleteAreaManager,
  getpastreports,
  getShopperListExcel,
  updateearlyinvoice,
  getVenueUsers,
  createveneuLogins,
  updateveneuLogins,
  updateAirTaskerStatus,
  getCancelledShopper,
  resetNewBundleAllocation,
  changeShopperOfBundle,
  CancelledAllocationTable,
  CopyTransportBundle,
  allocationSummary,
  AssignBulkAllocation,
  CreateTrainingSlot,
  GetTrainingSlot,
  putUpdateTrainers,
  deletebookingslot,
  getPendingAllocation,
  getBulkApproveAllocation,
  createCopyAllBundles,
  importSiteUsers,
  importEmailPreference,
  updateIsTrainingRequired,
  rejectBundleAllocation,
  copyClientEntityTemplate,
  copyBusinessCategoryQuestion,
  copyVenueCategoryQuestion,
  updateTempQuestionData,
  copyTemplateQuestionCategory,
  updateAvailabilitySlot,
  addvenuequestionsWithTemplateId,
  aldiallocationSummaryExcel,
  deleteCatgory,
  inviteBundle,
  completeSlot,
  resetSlot,
  copyLogo,
  copyDateChangeRequestForVenue,
  updateQuestionOption,
  getAirtaskerShopperList,
  activeShopperWithoutReport,
  exportactiveShopperWithoutReport,
  copyVenueTemplate,
  generateABA,
  disabledTrainings,
  unBookedTrainings,
  getRelatedVenueIds,
  updateRelatedVenueIds,
  createRelatedVenueIds,
  deleteRelatedVenueIds,
  sampleReport,
  allocationWarning,
  downloadQuestions,
  importBulkAssignShopper,
  deleteuser,
  createvenuenotes,
  venuenotes,
  createsampleallocation,
  deletveneuLogins,
  getShopperAppliedAllocationsExcel,
  getbriefjsonInfoData,
  getHolidays,
  createHolidays,
  deleteHolidays,
  deleteBusinessHolidays,
  createBusinessHolidays,
  updateBusinessHolidays,
  getBusinessHolidays,
  monthlytrainings,
  getquestionusage,
  createStaffManager,
  getStaffManager,
  updateStaffManager,
  deleteStaffManager,
  createScenario,
  getScenario,
  updateScenario,
  deleteScenario,
  getManagerScenarioListOfAllocation,
  getChecklistCategorylist,
  createChecklistCategory,
  updateChecklistCategory,
  deleteChecklistCategory,
  getChecklistQuestions,
  createChecklistQuestion,
  updateChecklistQuestion,
  getChecklistTemplateListing,
  createChecklistTemplate,
  updateChecklistTemplate,
  getChecklistTemplateQuestions,
  updateChecklistTemplateQuestion,
  deleteChecklistTemplateQuestion,
  createChecklistTemplateQuestion,
  addBriefIcon,
  getBriefIconList,
  updateBriefIcon,
  addBriefTitle,
  getBriefTitleList,
  updateBriefTitle,
  addBrief,
  getBriefList,
  updateBrief,
  deleteBrief,
  saveBriefHeader,
  copyBusinessBriefToVenue,
  copyShopperList,
  updateBriefStatus,
  CheckShopperEligibility,
  updaetRetakeQuiz,
  getNewBrief,
  resend2FA,
  updateBriefOrder,
  updateRestrictRemark
} from './ApiEndPoint.tsx'
import { baseApiCall } from './BaseApiCall.tsx'

export const ApiUsersLogin = (data: any) => {
  return baseApiCall({
    url: usersLogin,
    method: 'post',
    data
  })
}

export const ApiGetAllRoles = (data: any) => {
  return baseApiCall({
    url: getAllRoles,
    method: 'get',
    data
  })
}

export const ApiGetAdminList = (data = '') => {
  return baseApiCall({
    url: getAdminList + data,
    method: 'get'
  })
}
export const ApiGetClientEntities = (data?: any) => {
  return baseApiCall({
    url: data ? getClientEntities + data : getClientEntities,
    method: 'get',
    data
  })
}

export const ApiGetUserDetails = (id: any) => {
  return baseApiCall({
    url: getUserDetails + id,
    method: 'get'
  })
}
export const ApiPostCreateAdmin = (data: any) => {
  return baseApiCall({
    url: postCreateAdmin,
    method: 'post',
    data
  })
}
export const ApiPutUpdateClient = (data: any) => {
  return baseApiCall({
    url: putUpdateClient,
    method: 'put',
    data
  })
}

export const ApiPostCreateClient = (data: any) => {
  return baseApiCall({
    url: postCreateClient,
    method: 'post',
    data
  })
}
export const ApiGetClients = (data?: any) => {
  return baseApiCall({
    url: getClients + data,
    method: 'get'
  })
}
export const ApiPutDeleteClient = (clientId: any) => {
  return baseApiCall({
    url: putDeleteClient + clientId,
    method: 'put'
  })
}
export const ApiPutStoreStatus = (data: any) => {
  return baseApiCall({
    url: putStoreStatus,
    method: 'put',
    data
  })
}
export const ApiPutUpdateClientEntity = (data: any) => {
  return baseApiCall({
    url: putUpdateClientEntity,
    method: 'put',
    data
  })
}
export const ApiPostCreateClientEntity = (data: any) => {
  return baseApiCall({
    url: postCreateClientEntity,
    method: 'post',
    data
  })
}

export const ApiGetEntityTypeList = () => {
  return baseApiCall({
    url: getEntityTypeList,
    method: 'get'
  })
}

export const ApiGetVenueList = (data: any) => {
  return baseApiCall({
    url: getVenueList + data,
    method: 'get'
  })
}
export const ApiPutVenueStatus = (data: any) => {
  return baseApiCall({
    url: putVenueStatus,
    method: 'put',
    data
  })
}

export const ApiPostCreateVenue = (data: any) => {
  return baseApiCall({
    url: postCreateVenue,
    method: 'post',
    data
  })
}
export const ApiPutUpdateVenue = (data: any) => {
  return baseApiCall({
    url: putUpdateVenue,
    method: 'put',
    data
  })
}

export const ApiPutUpdateAdminDetails = (data: any) => {
  return baseApiCall({
    url: putUpdateAdminDetails,
    method: 'put',
    data
  })
}

export const ApiPutUpdateAdminRole = (data: any) => {
  return baseApiCall({
    url: putUpdateAdminRole,
    method: 'put',
    data
  })
}

export const ApiPutUpdateAdminStatus = (data: any) => {
  return baseApiCall({
    url: putUpdateAdminStatus,
    method: 'put',
    data
  })
}

export const ApiGetShopType = () => {
  return baseApiCall({
    url: getShopType,
    method: 'get'
  })
}

export const ApiGetStarRating = (data: any) => {
  return baseApiCall({
    url: getStarRating + data,
    method: 'get'
  })
}

export const ApiGetStarRatingData = (data: any) => {
  return baseApiCall({
    url: getStarRating + data,
    method: 'get'
  })
}

export const ApiDeleteStarRatingData = (data: any) => {
  return baseApiCall({
    url: getStarRating + data,
    method: 'delete'
  })
}

export const ApiCreateStarRatingData = (data: any) => {
  return baseApiCall({
    url: getStarRating,
    method: 'put',
    data
  })
}

export const ApiGetBriefJson = (data = '') => {
  return baseApiCall({
    url: getBriefJson + data,
    method: 'get'
  })
}
export const ApiPutBriefJson = (data: any) => {
  return baseApiCall({
    url: getBriefJson,
    method: 'put',
    data
  })
}

export const ApiPostBriefJson = (data: any) => {
  return baseApiCall({
    url: getBriefJson,
    method: 'post',
    data
  })
}

export const ApiDeleteBriefJson = (data: any) => {
  return baseApiCall({
    url: getBriefJson + data,
    method: 'delete',
  })
}

export const ApiPutUpdateEditors = (data: any) => {
  return baseApiCall({
    url: putUpdateEditors,
    method: 'put',
    data
  })
}

export const ApiPutVenueUpdateEditors = (data: any) => {
  return baseApiCall({
    url: putVenueEditors,
    method: 'put',
    data
  })
}

export const ApiGetClientEntityListById = (data: any) => {
  return baseApiCall({
    url: getClientEntities + data,
    method: 'get'
  })
}

export const ApiGetVisitTimes = (data:any=" ") => {
  return baseApiCall({
    url: getVisitTimes + data,
    method: 'get'
  })
}

export const ApiPostVisitTimes = (data: any) => {
  return baseApiCall({
    url: postVisitTimes,
    method: 'post',
    data
  })
}

export const ApiPutVisitTimes = (data: any) => {
  return baseApiCall({
    url: putVisitTimes,
    method: 'put',
    data
  })
}

export const ApiPostClientEntityTemplate = (data: any) => {
  return baseApiCall({
    url: postClientEntityTemplate,
    method: 'post',
    data
  })
}

export const ApiGetClientEntitiTemplate = (data: any) => {
  return baseApiCall({
    url: getClientEntityTemplateByClientEntityId + data,
    method: 'get'
  })
}

export const ApiPutClientEntityTemplate = (data: any) => {
  return baseApiCall({
    url: putClientEntityTemplate,
    method: 'put',
    data
  })
}

export const ApiPostVenueTemplate = (data: any) => {
  return baseApiCall({
    url: postVenueTemplate,
    method: 'post',
    data
  })
}
export const ApiPutVenueTemplate = (data: any) => {
  return baseApiCall({
    url: postVenueTemplate,
    method: 'put',
    data
  })
}

export const ApiGetVenueEntityTemplate = (data: any) => {
  return baseApiCall({
    url: getVenueEntityTemplateByClientEntityId + data,
    method: 'get'
  })
}

export const ApiGetAllocations = (data: any) => {
  return baseApiCall({
    url: getAllocations + data,
    method: 'get'
  })
}
export const ApiGetAdminMonthlyAllocations = (data: any) => {
  return baseApiCall({
    url: getMonthlyAllocation + data,
    method: 'get'
  })
}
export const ApiPutUpdateAllocation = (data: any) => {
  return baseApiCall({
    url: putUpdateAllocation,
    method: 'put',
    data
  })
}
export const ApiPostCreateAllocations = (data: any) => {
  return baseApiCall({
    url: postCreateAllocations,
    method: 'post',
    data
  })
}
export const ApiGetShopper = (data: any) => {
  return baseApiCall({
    url: getShopper + data,
    method: 'get'
  })
}
export const ApiGetOrphanAllocations = (data: any) => {
  return baseApiCall({
    url: getOrphanAllocations + data,
    method: 'get'
  })
}

export const ApiGetNearbyShopper = (data: any) => {
  return baseApiCall({
    url: getNearbyShopper + data,
    method: 'get'
  })
}

export const ApiGetShoppersApplication = (data:any) => {
  return baseApiCall({
    url: getAllShoppersApplications + data,
    method: 'get'
  })
}

export const ApiPutUpdateShopperApplicationStatus = (data: any) => {
  return baseApiCall({
    url: putUpdateShopperApplicationStatus,
    method: 'put',
    data
  })
}

export const ApiGetAppliedAllocations = (data: any) => {
  return baseApiCall({
    url: getAppliedAllocations + data,
    method: 'get',
  })
}

export const ApiPostUpdateAppliedAllocationStatus = (data: any) => {
  return baseApiCall({
    url: postUpdateAppliedAllocationStatus,
    method: 'post',
    data
  })
}

export const ApiPostInviteShopper = (data: any) => {
  return baseApiCall({
    url: postInviteShopper,
    method: 'post',
    data
  })
}
export const GetCategories = () => {
  return baseApiCall({
    url: getcategories,
    method: 'get',
  })
}
export const GetEntities = () => {
  return baseApiCall({
    url: getentities,
    method: 'get',
  })
}
export const AddNewQuestion = (data: any) => {
  return baseApiCall({
    url: addquestions,
    method: 'post',
    data
  })
}
export const UpdateQuestion = (data: any) => {
  return baseApiCall({
    url: updatequestions,
    method: 'put',
    data
  })
}
export const GetQuestions = (offset: number, limit: number, entityTypeId: number | string, categoryId: number | string, search: string, questionId:string) => {
  return baseApiCall({
    url: `${getquestions}?offset=${search.length > 0 ? 0 : offset}&limit=${limit}${categoryId !== 0 ? `&categoryId=${categoryId}` : ''}${entityTypeId !== 0 ? `&entityTypeId=${entityTypeId}` : ''}${search?.length > 0 ? `&search=${search}` : ''}${!questionId ? "&isActive=1":""}${questionId ? `&questionId=${questionId}`:""}`,
    method: 'get',
  })
}
export const DeleteQuestionTemplate = (entityTypeTemplateId: number) => {
  return baseApiCall({
    url: `${deletequestiontemplate}?entityTypeTemplateId=${entityTypeTemplateId}`,
    method: 'delete',
  })
}
export const GetQuestionTemplate = () => {
  return baseApiCall({
    url: getquestiontemplate,
    method: 'get',
  })
}
export const ApiPostUploadVenueImage = (data: any) => {
  return baseApiCall({
    url: uploadVenueImage,
    method: 'post',
    data
  })
}
export const AddQuestionTemplate = (data: any) => {
  return baseApiCall({
    url: addquestiontemplate,
    method: 'post',
    data
  })
}
export const UpdateQuestionTemplate = (data: any) => {
  return baseApiCall({
    url: updatequestiontemplate,
    method: 'put',
    data
  })
}
export const GetTemplateQuestions = (entityTypeTemplateId: number) => {
  return baseApiCall({
    url: `${gettemplatequestions}?entityTypeTemplateId=${entityTypeTemplateId}`,
    method: 'get',
  })
}
export const GetClientEntityQuestions = (clientEntityId: number) => {
  return baseApiCall({
    url: `${getcliententityquestions}?clientEntityId=${clientEntityId}`,
    method: 'get',
  })
}
export const AddTemplateQuestions = (data: any) => {
  return baseApiCall({
    url: addtemplatequestions,
    method: 'post',
    data
  })
}
export const AddBusinessQuestions = (data: any) => {
  return baseApiCall({
    url: addbusinessquestions,
    method: 'post',
    data
  })
}
export const RemoveTemplateQuestions = (entityTypeTemplateQuestionId: number) => {
  return baseApiCall({
    url: `${removetemplatequestions}?entityTypeTemplateQuestionId=${entityTypeTemplateQuestionId}`,
    method: 'post',
    // data
  })
}
export const RemoveClientQuestions = (clientEntityQuestionId: number | boolean, clientEntityId: number) => {
  return baseApiCall({
    url: `${removebusinessquestions}?${clientEntityQuestionId === true ? 'allDataNeedToDelete' : 'clientEntityQuestionId'}=${clientEntityQuestionId}&clientEntityId=${clientEntityId}`,
    method: 'delete',
    // data
  })
}
export const UpdateBusinessQuestions = (data: any) => {
  return baseApiCall({
    url: updatebusinessquestions,
    method: 'put',
    data
  })
}

export const AddVenueQuestions = (data: any) => {
  return baseApiCall({
    url: addvenuequestions,
    method: 'post',
    data
  })
}
export const GetVenueQuestions = (venueId: number) => {
  return baseApiCall({
    url: `${getvenuequestions}?venueId=${venueId}`,
    method: 'get',
  })
}
export const RemoveVenueQuestions = (clientEntityQuestionVenueId: number | boolean, venueId: number) => {
  return baseApiCall({
    url: `${removevenuequestions}?${clientEntityQuestionVenueId === true ? 'allDataNeedToDelete' : 'clientEntityQuestionVenueId'}=${clientEntityQuestionVenueId}&venueId=${venueId}`,
    method: 'delete',
    // data
  })
}
export const UpdateVenueQuestions = (data: any) => {
  return baseApiCall({
    url: updatevenuequestions,
    method: 'put',
    data
  })
}
export const UpdateVenueQuestionOrder = (data: any) => {
  return baseApiCall({
    url: updatevenuequestionorder,
    method: 'post',
    data
  })
}
export const UpdateVenueCategoryOrder = (data: any) => {
  return baseApiCall({
    url: updatevenuecategoryorder,
    method: 'post',
    data
  })
}
export const ApiPutCancelJob = (data: any) => {
  return baseApiCall({
    url: putCancelJob + data,
    method: 'put'
  })
}

export const ApiGetClientDbName = () => {
  return baseApiCall({
    url: getClientDbName,
    method: 'get'
  })
}
export const ApiMasterRating = () => {
  return baseApiCall({
    url: masterRating,
    method: 'get'
  })
}
export const ApiReportTempToken = (data:any) => {
  return baseApiCall({
    url: reporttemptoken,
    method: 'post',
    data
  })
}

// export const ApiReportList = (page: number, rowsperpage: number, reportMonth: number, reportYear: number, reportstatusId: number) => {
//   return baseApiCall({
//     url: `${reportlist}?offset=${page}&limit=${rowsperpage}&reportMonth=${reportMonth}&reportYear=${reportYear}&reportStatusId=${reportstatusId}`,
//     method: 'get',
//   })
// }
// export const ApiShopperFeedback = (reportHeaderId: number) => {
//   return baseApiCall({
//     url: `${getShopperFeedback}?reportHeaderId=${reportHeaderId}`,
//     method: 'get',
//   })
// }
// export const ApiPostShopperFeedback = (data: any) => {
//   return baseApiCall({
//     url: postShopperFeedback,
//     method: 'post',
//     data
//   })
// }
export const ApiUpdateVisitTime = (data: any) => {
  return baseApiCall({
    url: updatevisittime,
    method: 'put',
    data
  })

}

// export const ApiCallGetReportDetails = (data: any) => {
//   return baseApiCall({
//     url: getReportDetails + data,
//     method: 'get',
//   })
// }

// export const ApiScoreCardStep1 = (data: any) => {
//   return baseApiCall({
//     url: scoreCardStep1,
//     method: 'post',
//     data
//   });
// }

// export const ApiScoreCardStep2 = (data: any) => {
//   return baseApiCall({
//     url: scoreCardStep2,
//     method: 'post',
//     data
//   });
// }

// export const ApiScoreCardStep3 = (data: any) => {
//   return baseApiCall({
//     url: scoreCardStep3,
//     method: 'post',
//     data
//   });
// }

export const ApiDeletePhotos = (data: any) => {
  return baseApiCall({
    url: deletePhotos,
    method: 'Delete',
    data
  });
}

export const ApiGenerateReportPdf = (data: any) => {
  return baseApiCall({
    url: reportPdf + data,
    method: 'get',
  });
}
export const ApiUpdateAllocationDateTime = (data: any) => {
  return baseApiCall({
    url: updateallocationdatetime,
    method: 'post',
    data
  });
}
export const ApiUpdateAllocationDateTimeWithoutRequest = (data: any) => {
  return baseApiCall({
    url: updateallocationdatetimewithoutrequest,
    method: 'post',
    data
  });
}

// export const ApiUpdateReportStatus = (data: any) => {
//   return baseApiCall({
//     url: updateReportStatus,
//     method: 'put',
//     data
//   })
// }

export const ApiGetStarRatingReport = (data?: any) => {
  return baseApiCall({
    url: getStarRatingReport + data,
    method: 'get',
  })
}
export const ApiGetSpentReport = (data?: any) => {
  return baseApiCall({
    url: getSpentReport + data,
    method: 'get',
  })
}

export const ApiGetClientEntityByClientGroupId = (data: any) => {
  return baseApiCall({
    url: getClientEntityByClientGroupId + data,
    method: 'get'
  })
}

export const ApiAddAreaManager = (data: any) => {
  return baseApiCall({
    url: postAreaManager,
    method: 'post',
    data
  })
}

export const ApiGetAreaManager = (data: any) => {
  return baseApiCall({
    url: getAreaManagers + data,
    method: 'get'
  })
}

export const ApiUpdateAreaManager = (data: any) => {
  return baseApiCall({
    url: putAreaManager,
    method: 'put',
    data
  })
}

export const ApiDeleteAreaManager = (data: any) => {
  return baseApiCall({
    url: deleteAreaManager,
    method: 'put',
    data
  })
}

export const ApiGetAddOnQuestions = () => {
  return baseApiCall({
    url: getAddOnQuestions,
    method: 'get'
  })
}

export const ApiuploadDocuments = (data: any) => {
  return baseApiCall({
    url: uploadDocuments,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const ApiPostQuizQuestion = (data: any) => {
  return baseApiCall({
    url: postQuizQuestion,
    method: 'post',
    data
  })
}

export const ApiGetQuizQuestions = (data: any) => {
  return baseApiCall({
    url: getQuizQuestions + data,
    method: 'get'
  })
}

export const ApiPutQuizQuestion = (data: any) => {
  return baseApiCall({
    url: putQuizQuestions,
    method: 'put',
    data
  })
}
export const ApiRetakeQuiz = (data: any) => {
  return baseApiCall({
    url: updaetRetakeQuiz,
    method: 'put',
    data
  })
}

export const ApiSubmitQuiz = (data: any) => {
  return baseApiCall({
    url: submitQuiz,
    method: 'post',
    data
  })
}

export const ApiDeleteQuizQuestion = (data: any) => {
  return baseApiCall({
    url: deleteQuizQuestion,
    method: 'delete',
    data
  })
}

export const ApiGetShopperList = (data: any = '') => {
  return baseApiCall({
    url: getShopperList + data,
    method: 'get',
  })
}
export const ApiGetAirTaskerShopperList = (data: any = '') => {
  return baseApiCall({
    url: getAirtaskerShopperList + data,
    method: 'get',
  })
}
export const ApiGetWithoutReportShopperList = (data: any = '') => {
  return baseApiCall({
    url: activeShopperWithoutReport + data,
    method: 'get',
  })
}
export const ApiExportWithoutReportShopperList = (data: any = '') => {
  return baseApiCall({
    url: exportactiveShopperWithoutReport,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}

export const ApiPutShopperDetails = (data: any) => {
  return baseApiCall({
    url: putShopperDetails,
    method: 'put',
    data
  })
}

export const ApiPutShopperFinancialDetails = (data: any) => {
  return baseApiCall({
    url: putShopperFinancialDetails,
    method: 'put',
    data
  })
}

export const ApiGetShopperDetails = (data: any) => {
  return baseApiCall({
    url: getShopperDetails + data,
    method: 'get'
  })
}

export const ApiGetShopperRelativeVenues = (data: any) => {
  return baseApiCall({
    url: getShopperRelativeVenues + data,
    method: 'get'
  })
}

export const ApiGetShopperVenueMap = (data: any) => {
  return baseApiCall({
    url: getShopperVenueMap + data,
    method: 'get'
  })
}

export const ApiGetShopperPopUpDetails = (data: any) => {
  return baseApiCall({
    url: getShopperPopUpDetails + data,
    method: 'get'
  })
}

export const ApiGetManageRegions = (data:any="") => {
  return baseApiCall({
    url: getManageRegions + data,
    method: 'get'
  })
}

export const ApiPostRegion = (data: any) => {
  return baseApiCall({
    url: postRegion,
    method: 'post',
    data
  })
}

export const ApiPutRegion = (data: any) => {
  return baseApiCall({
    url: putRegion,
    method: 'put',
    data
  })
}

export const ApiPostAssignRegionToClientEntity = (data: any) => {
  return baseApiCall({
    url: postAssignRegionToClientEntity,
    method: 'post',
    data
  })
}

export const ApiGetBusinessRegions = (data: any) => {
  return baseApiCall({
    url: getBusinessRegions + data,
    method: 'get'
  })
}
export const ApiGetClientEntityComparisionsByEntityType = (data: any) => {
  return baseApiCall({
    url: getClientEntityComparisionsByEntityType,
    method: 'post',
    data: data
  })
}

export const ApiGetVenuePreviousReports = (data: any) => {
  return baseApiCall({
    url: getVenuePreviousReport + data,
    method: 'get',
  })
}

export const ApiGetApproveAllocationShopper = (data: any) => {
  return baseApiCall({
    url: getApprovedAllocationShopper + data,
    method: 'get',
  })
}
export const ApiGetCategoryList = (data:any="") => {
  return baseApiCall({
    url: getCategoryList + data,
    method: 'get'
  })
}
export const ApiAddCategory = (data: any) => {
  return baseApiCall({
    url: addCategory,
    method: 'post',
    data
  })
}
export const ApiUpdateCategory = (data: any) => {
  return baseApiCall({
    url: updateCategory,
    method: 'put',
    data
  })
}
export const ApiQuizreTake = (data: any) => {
  return baseApiCall({
    url: quizreTake,
    method: 'put',
    data
  })
}

export const ApiGetRegionBusinessDetails = (data:any="") => {
  return baseApiCall({
    url: getRegionBusinessDetails + data,
    method: 'get'
  })
}

export const ApiPostRegionBusinessDetail = (data: any) => {
  return baseApiCall({
    url: postregionBusinessDetail,
    method: 'post',
    data
  })
}

export const ApiPutquizBrief = (data: any) => {
  return baseApiCall({
    url: putQuizBrief,
    method: 'put',
    data
  })
}

export const ApiDeleteReportMessage = (data: any) => {
  return baseApiCall({
    url: delReportMessage + data,
    method: 'delete',
  });
}

export const ApiGetAllocationCriteriaDetails = (data: any) => {
  return baseApiCall({
    url: getAllocationCriteriaDetails + data,
    method: 'get',
    // data
  })
}

export const ApicreateAirTasker = (data: any) => {
  return baseApiCall({
    url: createAirTasker,
    method: 'post',
    data
  })
}

export const ApiupdateAirTasker = (data: any) => {
  return baseApiCall({
    url: updateAirTasker,
    method: 'put',
    data
  })
}

export const ApideleteAirTasker = (data: any) => {
  return baseApiCall({
    url: deleteAirTasker,
    method: 'put',
    data
  })
}

export const ApiGetAirTasker = (data: any) => {
  return baseApiCall({
    url: getAirTasker + data,
    method: 'get'
  })
}
export const ApiGetAllocationlist = (data: any) => {
  return baseApiCall({
    url: getallocations + data,
    method: 'get'
  })
}

export const ApideleteInvitedAirTasker = (data: any) => {
  return baseApiCall({
    url: deleteInvitedAirTasker,
    method: 'put',
    data
  })
}
export const ApiCreateBundleAllocation = (data: any) => {
  return baseApiCall({
    url: createbundleallocations,
    method: 'post',
    data
  })
}
export const ApiGetBundleList = (data = '') => {
  return baseApiCall({
    url: getbundlelist + data,
    method: 'get',
  })
}
export const ApiGetBundleAllocations = (data:any) => {
  return baseApiCall({
    url: getbundleallocations + data,
    method: 'get',
    data
  })
}
export const ApiGetAppliedBundleAllocations = (data:any) => {
  return baseApiCall({
    url: getappliedbundleallocations + data,
    method: 'get',
    data
  })
}
export const ApiPostUpdateBundleAppliedAllocationStatus = (data: any) => {
  return baseApiCall({
    url: postupdateappliedbundleallocations,
    method: 'post',
    data
  })
}
export const ApiHoldAppliedAllocation = (data1: any, data2: any) => {
  return baseApiCall({
    url: holdappliedallocations + data1,
    method: 'post',
    data: data2
  })
}
export const ApiHoldBundleAppliedAllocation = (data1: any, data2: any) => {
  return baseApiCall({
    url: holdbundleappliedallocations + data1,
    method: 'post',
    data: data2
  })
}
export const ApiCriteriaMessage = (data1: any) => {
  return baseApiCall({
    url: criteriamessage + data1,
    method: 'get',
  })
}
export const ApiUpdateDateTime = (data: any) => {
  return baseApiCall({
    url: updatedatetime,
    method: 'put',
    data
  })
}
export const ApiImportExportAllocationTable = (data: any) => {
  return baseApiCall({
    url: importexportallocationtabledata + data,
    method: 'get',
    data
  })
}
export const ApiImportExportAllocationPoints = (data: any) => {
  return baseApiCall({
    url: importexportallocationpointsdata + data,
    method: 'get',
    data
  })
}
export const ApiGetCompleteAllocation = (data: any) => {
  return baseApiCall({
    url: getCompleteAllocation + data,
    method: 'get',
  })
}
export const ApiGetInvoiceReportList = (data: any) => {
  return baseApiCall({
    url: getinvoicereportlist + data,
    method: 'get',
  })
}
export const ApiResetAllocation = (data: any) => {
  return baseApiCall({
    url: resetallocation + data,
    method: 'put',
  })
}
export const ApiDeleteAllocation = (data: any) => {
  return baseApiCall({
    url: deleteallocation + data,
    method: 'delete',
  })
}
export const ApiEditorClientEntities = (data: any) => {
  return baseApiCall({
    url: editorcliententities + data,
    method: 'get',
  })
}
export const ApiEditorVenueList = (data: any) => {
  return baseApiCall({
    url: editorvenuelist + data,
    method: 'get',
  })
}

export const ApiGenerateInvoice = (data: any) => {
  return baseApiCall({
    url: generateinvoice,
    method: 'post',
    data
  })
}
export const ApiGetInvoiceStatus = () => {
  return baseApiCall({
    url: invoicestatus,
    method: 'get',
  })
}
export const ApiGetGeneratedInvoiceList = (data:any) => {
  return baseApiCall({
    url: getgeneratedinvoicelist + data,
    method: 'get',
  })
}
export const ApiUpdateBulkStatus = (data:any) => {
  return baseApiCall({
    url: updatebulkstatus,
    method: 'put',
    data
  })
}
export const ApiGetInvoiceItem = (data: any) => {
  return baseApiCall({
    url: getinvoiceitem + data,
    method: 'get',
  })
}
export const ApiUpdateInvoiceItem = (data: any) => {
  return baseApiCall({
    url: updateinvoiceitem,
    method: 'put',
    data
  })
}
export const ApiGetPriceChangeLogs = (data: any) => {
  return baseApiCall({
    url: getPriceChangeLogs + data,
    method: 'get',
  })
}
export const ApiGetAllocationForUpdate = (data: any) => {
  return baseApiCall({
    url: getAllocationForUpdate + data,
    method: 'get',
  })
}
export const ApiUpdateAllocationPrice = (data: any) => {
  return baseApiCall({
    url: updateAllocationPrice,
    method: 'put',
    data
  })
}
export const ApiDeleteAllocationPriceChangeLogsById = (data: any) => {
  return baseApiCall({
    url: deleteAllocationPriceChangeLogsById + data,
    method: 'delete',
  });
}
export const ApiDownloadAllAsXlsInImportExportAllocation = (data: any) => {
  return baseApiCall({
    url: downloadAllAsXlsInImportExportAllocation + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiDownloadExcelForOrphanInImportExportAllocation = (data: any) => {
  return baseApiCall({
    url: downloadExcelForOrphanInImportExportAllocation + data,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiDownloadPdfByStatusInImportExportAllocation = (data: any) => {
  return baseApiCall({
    url: downloadPdfByStatusInImportExportAllocation + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGenerateMasterInvoice = (data: any) => {
  return baseApiCall({
    url: generatemasterinvoiceexcel + data,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGenerateShopperWiseInvoice = (data: any) => {
  return baseApiCall({
    url: shopperwiseinvoiceexcel + data,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGenerateABA = (data: any) => {
  return baseApiCall({
    url: generateABA  + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGenerateShopperInvoice = (data: any) => {
  return baseApiCall({
    url: shopperinvoiceexcel + data,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGenerateShopperInvoicePDF = (data: any) => {
  return baseApiCall({
    url: shopperinvoicepdf + data,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGetStarRankingReportYTD = (data: any) => {
  return baseApiCall({
    url: getStarRankingReportYTD + data,
    method: 'get'
  })
}
export const ApiGetAirTaskerTasks = () => {
  return baseApiCall({
    url: getAirTaskerTasks,
    method: 'get'
  })
}
export const ApiGetExcelDataForAirTaskerJobs = () => {
  return baseApiCall({
    url: getExcelDataForAirTaskerJobs,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}

export const ApiAssignShooperAllocation = (data: any) => {
  return baseApiCall({
    url: assignShooperAllocation,
    method: 'post',
    data
  })
}
export const ApiGenerateLoginToken = (data: any) => {
  return baseApiCall({
    url: generatelogintoken,
    method: 'post',
    data
  })
}
export const ApiGetRestrictVenues = (data: any) => {
  return baseApiCall({
    url: getRestrictVenues+ data,
    method: 'get'
  })
}
export const ApiAddRestrictVenue = (data: any) => {
  return baseApiCall({
    url: addRestrictVenue,
    method: 'post',
    data
  })
}
export const ApiRemoveRestrictVenues = (data: any) => {
  return baseApiCall({
    url: deleteRestrictVenue,
    method: 'put',
    data
  })
}
export const ApiUpdateRestrictRemark = (data: any) => {
  return baseApiCall({
    url: updateRestrictRemark,
    method: 'put',
    data
  })
}
export const ApiStarRatingExcel = (data: any) => {
  return baseApiCall({
    url: starRatingExcel + data,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiGetClientEntityComparisionsByEntityTypeExcel = (data: any) => {
  return baseApiCall({
    url: getClientEntityComparisionsByEntityTypeExcel,
    method: 'post',
    data,
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiRatingReportYTD = (data: any) => {
  return baseApiCall({
    url: ratingReportYTD + data,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiCreateEmailPreference = (data:any) => {
  return baseApiCall({
    url: createEmailPreference,
    method: 'post',
    data
  })
}
export const ApiGetEmailPreference = (data: any) => {
  return baseApiCall({
    url: getEmailPreference + data,
    method: 'get'
  })
}
export const ApiDeleteEmailPreference = (data: any) => {
  return baseApiCall({
    url: deleteEmailPreference + data,
    method: 'delete',
  })
}
export const ApiUpdateEmailPreference = (data: any) => {
  return baseApiCall({
    url: updateEmailPreference,
    method: 'put',
    data
  })
}
export const ApiCreateOrUpdateHoliday = (data: any) => {
  return baseApiCall({
    url: ManageHolidays,
    method: 'put',
    data
  })
}
export const ApiGetHoliday = (data: any) => {
  return baseApiCall({
    url: ManageHolidays + data,
    method: 'get',
  })
}
export const ApiDeleteHoliday = (data: any) => {
  return baseApiCall({
    url: ManageHolidays + data,
    method: 'delete',
  })
}
export const ApiExportCheckedInvoice = (data:any) => {
  return baseApiCall({
    url: exportcheckedshopper + data,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiReportInvoiceExcel = (data:any) => {
  return baseApiCall({
    url: generatereportinvoiceexcel + data,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGetVenuesExcel = (data: any) => {
  return baseApiCall({
    url: downloadVenuesExcel + data,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiGetBusinessExcel = () => {
  return baseApiCall({
    url: downloadBusinessExcel,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiGetBusinessQuestionExcel = (data: any) => {
  return baseApiCall({
    url: downloadBusinessQuestionExcel + data,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiGetVenueQuestionExcel = (data: any) => {
  return baseApiCall({
    url: downloadVenuesQuestionExcel + data,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiGetAddOnQuestionData = (data: any) => {
  return baseApiCall({
    url: getAddOnQuestionList + data,
    method: 'get',
  })
}
export const ApiCreateAddOnQuestionData = (data: any) => {
  return baseApiCall({
    url: getAddOnQuestionList,
    method: 'put',
    data
  })
}
export const ApiDeleteAddOnQuestionData = (data: any) => {
  return baseApiCall({
    url: getAddOnQuestionList + data,
    method: 'delete',
  })
}
export const ApiImportVenue = (data: any) => {
  return baseApiCall({
    url: importVeneus,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const ApiGetSpentReportExcel = (data: any) => {
  return baseApiCall({
    url: getSpentReportExcel + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiChangeApproveAllocationsDate = (data:any) => {
  return baseApiCall({
    url: ChangeApproveAllocationsDate,
    method: 'post',
    data
  })
}
export const ApiChangeOrphanAllocationsDate = (data:any) => {
  return baseApiCall({
    url: ChangeOrphanAllocationsDate,
    method: 'post',
    data
  })
}
export const ApiResetBulkAllocation = (data:any) => {
  return baseApiCall({
    url: BulkResetAllocation,
    method: 'post',
    data
  })
}
export const ApiUpdateBundleAllocation = (data:any) => {
  return baseApiCall({
    url: updateBundleAllocation,
    method: 'put',
    data
  })
}
export const ApiDeleteBundleAllocation = (data:any) => {
  return baseApiCall({
    url: deleteBundleAllocation + data,
    method: 'delete',
  })
}
export const ApiGetDocumentType = () => {
  return baseApiCall({
    url: getDocumentType,
    method: 'get',
  })
}
export const ApiGetDocuments = (data:any) => {
  return baseApiCall({
    url: getDocument + data,
    method: 'get',
  })
}
export const ApiCreateHelpingDocument = (data:any) => {
  return baseApiCall({
    url: createDocument,
    method: "post",
    data
  })
}
export const ApiUpdateHelpingDocument = (data:any) => {
  return baseApiCall({
    url: updateHelpingDocument,
    method: 'put',
    data
  })
}
export const ApiDeleteHelpingDocument = (data:any) => {
  return baseApiCall({
    url: deleteHelpingDocument + data,
    method: 'delete',
  })
}
export const ApiGetNewBundleList = (data:any) => {
  return baseApiCall({
    url: newBundleList + data,
    method: 'get',
  })
}
export const ApiCreateNewBundleAllocation = (data:any) => {
  return baseApiCall({
    url: newCreateBundleList,
    method: 'post',
    data
  })
}
export const ApiUpdateNewBundleAllocation = (data:any) => {
  return baseApiCall({
    url: updateNewBundleList,
    method: 'put',
    data
  })
}
export const ApiDeleteNewBundleAllocation = (data:string) => {
  return baseApiCall({
    url: deleteNewBundleList + data,
    method: 'delete',
  })
}
export const ApiGetNewAppliedBundleAllocation = (data:string) => {
  return baseApiCall({
    url: getNewAppliedBundleAllocation + data,
    method: 'get',
  })
}
export const ApiApproveShopperBundle = (data:any) => {
  return baseApiCall({
    url: approveShopperBundle,
    method: 'post',
    data
  })
}
export const ApiGetResetAllocationList = (data:string) => {
  return baseApiCall({
    url: BulkResetAllocationData + data,
    method: 'get',
  })
}
export const ApiBulkAssignShopper = (data:any) => {
  return baseApiCall({
    url: bulkAssignShopper,
    method: 'post',
    data
  })
}
export const ApiDownloadBulkRegionUpdate = (data: any) => {
  return baseApiCall({
    url: downloadBulkRegionUpdate + data,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiUploadBulkRegionUpdateExcel = (data: any) => {
  return baseApiCall({
    url: uploadBulkRegionUpdateExcel,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const ApiGetRoasterMaster = (data:any) => {
  return baseApiCall({
    url: exportRoasterMaster + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiRejectAppliedAllocation = (data: any) => {
  return baseApiCall({
    url: rejectAppliedAllocation + data,
    method: 'put',
  })
}

export const ApigetUserByClientId = (data: any) => {
  return baseApiCall({
    url: getUserByClientId + data,
    method: 'get',
  })
}

export const ApicreateOrUpdateUserByClientId = (data: any) => {
  return baseApiCall({
    url: createOrUpdateUserByClientId,
    method: 'post',
    data
  })
}

export const ApiGetShopperListExcel = (data: any) => {
  return baseApiCall({
    url: getShopperListExcel + data,
    method: 'get',
    responseType: 'blob',
  })
}
export const ApiUpdateEarlyInvoice = (data: any) => {
  return baseApiCall({
    url: updateearlyinvoice,
    method: 'put',
    data
  })
}

export const ApiGetVenueUsers = (data: any) => {
  return baseApiCall({
    url: getVenueUsers + data,
    method: 'get',
  })
}

export const ApiCreateVenueLogins = (data:any) => {
  return baseApiCall({
    url: createveneuLogins,
    method: 'post',
    data
  })
}
export const ApiUpdateVenueLogins = (data:any) => {
  return baseApiCall({
    url: updateveneuLogins,
    method: 'put',
    data
  })
}
export const ApiupdateAirTaskerStatus = (data:any) => {
  return baseApiCall({
    url: updateAirTaskerStatus,
    method: 'post',
    data
  })
}
export const ApiGetCancelledShopper = (data:any) => {
  return baseApiCall({
    url: getCancelledShopper + data,
    method: 'get',
  })
}
export const ApiResetNewBundleAllocation = (data:any) => {
  return baseApiCall({
    url: resetNewBundleAllocation + data,
    method: 'post',
  })
}
export const ApiChangeShopperOfBundle = (data:any) => {
  return baseApiCall({
    url: changeShopperOfBundle,
    method: 'post',
    data
  })
}
export const ApiGetTableOfCancelledAllocation = (data:any) => {
  return baseApiCall({
    url: CancelledAllocationTable + data,
    method: 'get',
  })
}
export const ApiCopyTransportBundle = (data:any) => {
  return baseApiCall({
    url: CopyTransportBundle,
    method: 'post',
    data
  })
}
export const ApiGetAllocationSummary = (data:any) => {
  return baseApiCall({
    url: allocationSummary + data,
    method: 'get',
  })
}
export const ApiAssignBulkAllocations = (data:any) => {
  return baseApiCall({
    url: AssignBulkAllocation,
    method: 'post',
    data
  })
}
export const ApiCreateTrainingSlot = (data:any) => {
  return baseApiCall({
    url: CreateTrainingSlot,
    method: 'post',
    data
  })
}
export const ApiGetTrainingSlot = (data:any) => {
  return baseApiCall({
    url: GetTrainingSlot + data,
    method: 'get',
  })
}
export const ApiGetPendingAllocation = (data:any) => {
  return baseApiCall({
    url: getPendingAllocation + data,
    method: 'get',
  })
}
export const ApiGetBulkApproveAllocation = (data:any) => {
  return baseApiCall({
    url: getBulkApproveAllocation + data,
    method: 'get',
  })
}
export const ApiPutUpdateTrainers = (data: any) => {
  return baseApiCall({
    url: putUpdateTrainers,
    method: 'put',
    data
  })
}
export const ApiDeleteBookingSlot = (data: any) => {
  return baseApiCall({
    url: deletebookingslot,
    method: 'put',
    data
  })
}
export const ApiCreateCopyAllBundles = (data: any) => {
  return baseApiCall({
    url: createCopyAllBundles,
    method: 'post',
    data
  })
}
export const ApiImportSiteUsers = (data: any) => {
  return baseApiCall({
    url: importSiteUsers,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const ApiImportEmailPreference = (data: any) => {
  return baseApiCall({
    url: importEmailPreference,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const ApiImportBulkAssignShopper = (data: any) => {
  return baseApiCall({
    url: importBulkAssignShopper,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const ApiUpdateIsTrainingRequired = (data:any) => {
  return baseApiCall({
    url: updateIsTrainingRequired + data,
    method: 'get',
  })
}
export const ApiRejectBundleAllocation = (data:any) => {
  return baseApiCall({
    url: rejectBundleAllocation + data,
    method: 'put',
  })
}
export const ApiCopyClientEntityTemplate = (data: any) => {
  return baseApiCall({
    url: copyClientEntityTemplate + data,
    method: 'post',
  })
}
export const ApiCopyVenueTemplate = (data: any) => {
  return baseApiCall({
    url: copyVenueTemplate + data,
    method: 'post',
  })
}
export const ApiCopyBusinessCategoryQuestion = (data: any) => {
  return baseApiCall({
    url: copyBusinessCategoryQuestion,
    method: 'post',
    data
  })
}
export const ApiCopyVenueCategoryQuestion = (data: any) => {
  return baseApiCall({
    url: copyVenueCategoryQuestion,
    method: 'post',
    data
  })
}
export const ApiUpdateTempQuestionData = (data: any, data1: any) => {
  return baseApiCall({
    url: updateTempQuestionData + data,
    method: 'put',
    data: data1
  })
}
export const ApiCopyTemplateQuestionCategory = (data: any) => {
  return baseApiCall({
    url: copyTemplateQuestionCategory,
    method: 'post',
    data
  })
}
export const ApiUpdateAvailabilitySlot  = (data: any) => {
  return baseApiCall({
    url: updateAvailabilitySlot ,
    method: 'put',
    data
  })
}
export const ApiaddvenuequestionsWithTemplateId  = (data: any) => {
  return baseApiCall({
    url: addvenuequestionsWithTemplateId ,
    method: 'post',
    data
  })
}
export const ApiAldiAllocationSummaryExcel  = (data: any) => {
  return baseApiCall({
    url: aldiallocationSummaryExcel + data,
    method: 'get',
    responseType: 'blob',
  })
}
export const ApiDeleteCatgory = (data: any) => {
  return baseApiCall({
    url: deleteCatgory,
    method: 'post',
    data
  })
}
export const ApiInviteBundle = (data: any) => {
  return baseApiCall({
    url: inviteBundle,
    method: 'post',
    data
  })
}
export const ApiCompleteSlot = (data: any) => {
  return baseApiCall({
    url: completeSlot,
    method: 'put',
    data
  })
}
export const ApiResetSlot = (data: any) => {
  return baseApiCall({
    url: resetSlot,
    method: 'put',
    data
  })
}
export const ApiCopyLogo = (data: any) => {
  return baseApiCall({
    url: copyLogo,
    method: 'post',
    data
  })
}
export const ApiCopyDateRequest = (data: any) => {
  return baseApiCall({
    url: copyDateChangeRequestForVenue,
    method: 'post',
    data
  })
}
export const ApiUpdateQuestionOption = (data: any) => {
  return baseApiCall({
    url: updateQuestionOption,
    method: 'put',
    data
  })
}
export const ApiGetDisabledTrainings = (data: any) => {
  return baseApiCall({
    url: disabledTrainings + data,
    method: 'get',
  })
}
export const ApiGetPendingTrainings = (data: any) => {
  return baseApiCall({
    url: unBookedTrainings + data,
    method: 'get',
  })
}

export const ApiGetRelatedVenues = () => {
  return baseApiCall({
    url: getRelatedVenueIds,
    method: 'get',
  })
}
export const ApiUpdateRelatedVenues = (data:any) => {
  return baseApiCall({
    url: updateRelatedVenueIds,
    method: 'put',
    data
  })
}
export const ApiCreateRelatedVenues = (data:any) => {
  return baseApiCall({
    url: createRelatedVenueIds,
    method: 'post',
    data
  })
}
export const ApiDeleteRelatedVenues = (data:any) => {
  return baseApiCall({
    url: deleteRelatedVenueIds + data,
    method: 'delete',
    
  })
}

export const ApiSampleReport = (data:any) => {
  return baseApiCall({
    url: sampleReport + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiGetAllocationWarning = (data:any) => {
  return baseApiCall({
    url: allocationWarning + data,
    method: 'get',
  })
}

export const ApiDowloadQuestions = (data:any) => {
  return baseApiCall({
    url: downloadQuestions + data,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiDeleteUser = (data:any) => {
  return baseApiCall({
    url: deleteuser + data,
    method: 'delete',
  })
}

export const ApiCreateVenueNotes = (data:any) => {
  return baseApiCall({
    url: venuenotes,
    method: 'post',
    data
  })
}
export const ApiUpdateVenueNotes = (data:any) => {
  return baseApiCall({
    url: venuenotes,
    method: 'put',
    data
  })
}
export const ApiDeleteVenueNotes = (data:any) => {
  return baseApiCall({
    url: venuenotes + data,
    method: 'delete',
    
  })
}

export const ApiCreateSampleAllocation = (data:any) => {
  return baseApiCall({
    url: createsampleallocation,
    method: 'post',
    data
    
  })
}

export const ApiDownloadShopperAppliedAllocationsExcel = (data:any) => {
  return baseApiCall({
    url: getShopperAppliedAllocationsExcel + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiGetbriefjsonInfoData = (data: any) => {
  return baseApiCall({
    url: getbriefjsonInfoData + data,
    method: 'get'
  })
}


export const ApiDeleteVenueLogins = (data: any) => {
  return baseApiCall({
    url: deletveneuLogins + data,
    method: 'delete',
  })
}
export const ApiGetBusinessHolidays = (data: any) => {
  return baseApiCall({
    url: getBusinessHolidays + data,
    method: 'get',
  })
}

export const ApiCreateBusinessHoliday = (data: any) => {
  return baseApiCall({
    url: createBusinessHolidays, 
    method: 'post',
    data,
  })
}
export const ApiUpdateBusinessHoliday = (data: any) => {
  return baseApiCall({
    url: updateBusinessHolidays, 
    method: 'put',
    data,
  })
}

export const ApiDeleteBusinessHolidays = (data: any) => {
  return baseApiCall({
    url: deleteBusinessHolidays + data,
    method: 'delete',
  })
}
export const ApiGetMonthlyTrainings = (data: any) => {
  return baseApiCall({
    url: monthlytrainings + data,
    method: 'get',
     responseType: 'blob'
  })
}

export const ApiGetQuestionUsage = (data: any) => {
  return baseApiCall({
    url: getquestionusage + data,
    method: 'get',
  })
}

export const ApiCreateStaffManager = (data: any) => {
  return baseApiCall({
    url: createStaffManager,
    method: 'post',
    data
  })
}
export const ApiGetStaffManager = (data: any) => {
  return baseApiCall({
    url: getStaffManager + data,
    method: 'get',
  })
}
export const ApiUpdateStaffManager = (data: any) => {
  return baseApiCall({
    url: updateStaffManager,
    method: 'put',
    data
  })
}
export const ApiDeleteStaffManager = (data: any) => {
  return baseApiCall({
    url: deleteStaffManager + data,
    method: 'delete',
  })
}

export const ApiCreateScenario = (data: any) => {
  return baseApiCall({
    url: createScenario,
    method: 'post',
    data
  })
}
export const ApiGetScenario = (data: any) => {
  return baseApiCall({
    url: getScenario + data,
    method: 'get',
  })
}
export const ApiUpdateScenario = (data: any) => {
  return baseApiCall({
    url: updateScenario,
    method: 'put',
    data
  })
}
export const ApiDeleteScenario = (data: any) => {
  return baseApiCall({
    url: deleteScenario + data,
    method: 'delete',
  })
}
export const ApiGetManagerScenarioListOfAllocation = (data: any) => {
  return baseApiCall({
    url: getManagerScenarioListOfAllocation + data,
    method: 'get',
  })
}



export const ApiGetChecklistCategoryList = (data:any="") => {
  return baseApiCall({
    url: getChecklistCategorylist + data,
    method: 'get'
  })
}
export const ApiAddChecklistCategory = (data: any) => {
  return baseApiCall({
    url: createChecklistCategory,
    method: 'post',
    data
  })
}
export const ApiUpdateChecklistCategory = (data: any) => {
  return baseApiCall({
    url: updateChecklistCategory,
    method: 'put',
    data
  })
}
export const ApiDeleteChecklistCategory = (data: any) => {
  return baseApiCall({
    url: deleteChecklistCategory + data,
    method: 'delete',
  })
}

export const ApiGetChecklistQuestions = (data:any="") => {
  return baseApiCall({
    url: getChecklistQuestions + data,
    method: 'get'
  })
}
export const ApiAddChecklistQuestion = (data: any) => {
  return baseApiCall({
    url: createChecklistQuestion,
    method: 'post',
    data
  })
}
export const ApiUpdateChecklistQuestion = (data: any) => {
  return baseApiCall({
    url: updateChecklistQuestion,
    method: 'put',
    data
  })
}

export const ApiGetChecklistTemplate = (data:any="") => {
  return baseApiCall({
    url: getChecklistTemplateListing + data,
    method: 'get'
  })
}
export const ApiAddChecklistTemplate = (data: any) => {
  return baseApiCall({
    url: createChecklistTemplate,
    method: 'post',
    data
  })
}
export const ApiUpdateChecklistTemplate = (data: any) => {
  return baseApiCall({
    url: updateChecklistTemplate,
    method: 'put',
    data
  })
}

export const ApiGetChecklistTemplateQuestions = (data:any="") => {
  return baseApiCall({
    url: getChecklistTemplateQuestions + data,
    method: 'get'
  })
}
export const ApiAddChecklistTemplateQuestion = (data: any) => {
  return baseApiCall({
    url: createChecklistTemplateQuestion,
    method: 'post',
    data
  })
}
export const ApiUpdateChecklistTemplateQuestion = (data: any) => {
  return baseApiCall({
    url: updateChecklistTemplateQuestion,
    method: 'put',
    data
  })
}

export const ApiDeleteChecklistTemplateQuestion = (data: any) => {
  return baseApiCall({
    url: deleteChecklistTemplateQuestion + data,
    method: 'delete',
  })
}

// Brief Icon APIs
export const ApiAddBriefIcon = (data: any) => {
  return baseApiCall({
    url: addBriefIcon,
    method: 'post',
    data
  })
}

export const ApiGetBriefIconList = (query: string = '') => {
  return baseApiCall({
    url: getBriefIconList + query,
    method: 'get'
  })
}

export const ApiUpdateBriefIcon = (data: any) => {
  return baseApiCall({
    url: updateBriefIcon,
    method: 'put',
    data
  })
}

// Brief Title APIs
export const ApiAddBriefTitle = (data: any) => {
  return baseApiCall({
    url: addBriefTitle,
    method: 'post',
    data
  })
}

export const ApiGetBriefTitleList = (query: string = '') => {
  return baseApiCall({
    url: getBriefTitleList + query,
    method: 'get'
  })
}

export const ApiUpdateBriefTitle = (data: any) => {
  return baseApiCall({
    url: updateBriefTitle,
    method: 'put',
    data
  })
}

// Business / Venue Brief APIs
export const ApiAddBrief = (data: any) => {
  return baseApiCall({
    url: addBrief,
    method: 'post',
    data
  })
}

export const ApiGetBriefList = (query: string = '') => {
  return baseApiCall({
    url: getBriefList + query,
    method: 'get'
  })
}

export const ApiUpdateBrief = (data: any) => {
  return baseApiCall({
    url: updateBrief,
    method: 'put',
    data
  })
}

export const ApiDeleteBrief = (data: any) => {
  return baseApiCall({
    url: deleteBrief,
    method: 'delete',
    data
  })
}

export const ApiSaveBriefHeader = (data: any) => {
  return baseApiCall({
    url: saveBriefHeader,
    method: 'post',
    data
  })
}

export const ApiCopyBusinessBriefToVenue = (data: any) => {
  return baseApiCall({
    url: copyBusinessBriefToVenue,
    method: 'post',
    data
  })
}

export const ApiUpdateNewBriefStatus= (data: any) => {
  return baseApiCall({
    url: updateBriefStatus,
    method: 'post',
    data
  })
}

export const ApiCopySopperList = (query: string = '') => {
  return baseApiCall({
    url: copyShopperList + query,
    method: 'get'
  })
}

export const ApiCheckShopperEligibility = (query: string = '') => {
  return baseApiCall({
    url: CheckShopperEligibility + query,
    method: 'get'
  })
}

export const ApiGetNewBrief = (data: any) => {
  return baseApiCall({
    url: getNewBrief + data,
    method: 'get',
  })

}

export const ApiGetResend2FA = (data: any) => {
  return baseApiCall({
    url: resend2FA,
    method: 'post',
    data
  })

}

export const ApiUpdateBriefDisplayOrder = (data: any) => {
  return baseApiCall({
    url: updateBriefOrder,
    method: 'put',
    data
  })

}